import { GuestHome } from "../../views/home/GuestHome";

export default function GuestHomePage() {
  return <GuestHome />;
}
